export const feedbackStatuses = ['new', 'in_progress', 'done'];
